import React from 'react';

const viewContext = React.createContext({location:null});

export default viewContext;